// @flow

import React, { Component } from "react";
import { noop, isEqual } from "lodash";
import type { UnaryFn } from "@tvg/types/Functional";
import type { PastPerformanceRace as PastPerformanceRaceType } from "@tvg/types/Race";
import { IppMask } from "../../_static/Masks";
import PastPerformance from "../../_molecule/PastPerformance";
import RaceList from "./styled-components";

type Props = {
  isLoading: boolean,
  races: PastPerformanceRaceType[],
  selectedRace: number,
  hasMoreButtonPresent: boolean,
  onRace: UnaryFn<number, void>,
  isMobile: boolean,
  postRaceReportShown: boolean,
  raceDistance: string,
  raceSurface: string
};

export default class PastPerformanceList extends Component<Props> {
  static defaultProps = {
    isLoading: true,
    races: [],
    selectedRace: -1,
    onRace: noop,
    hasMoreButtonPresent: false,
    isMobile: false,
    postRaceReportShown: false,
    raceDistance: "",
    raceSurface: ""
  };

  shouldComponentUpdate(nextProps: Props) {
    return (
      this.props.races.length !== nextProps.races.length ||
      !isEqual(this.props.races, nextProps.races) ||
      !isEqual(this.props, nextProps)
    );
  }

  createListFromRaces = () =>
    this.props.races.map((race: PastPerformanceRaceType, index: number) => (
      <li key={`pp-${race.track.code}-${race.number}-${race.date}`}>
        <PastPerformance
          key={`pp-${race.track.code}-${race.number}-${race.date}`}
          data-qa-label={`pp-${race.track.code}-${race.number}-${race.date}`}
          onClick={() => {
            this.props.onRace(index);
          }}
          distanceHighlighted={this.props.raceDistance === race.distance}
          surfaceHighlighted={this.props.raceSurface === race.surface.shortName}
          race={race}
          isSelected={
            this.props.selectedRace >= 0 && index === this.props.selectedRace
          }
          postRaceReportShown={this.props.postRaceReportShown}
        />
      </li>
    ));

  render() {
    return (
      <RaceList
        hasMoreButtonPresent={this.props.hasMoreButtonPresent}
        borderOnLastItem={this.props.isMobile}
        data-qa-label="ipp-races-list"
      >
        {this.props.isLoading ? <IppMask /> : this.createListFromRaces()}
      </RaceList>
    );
  }
}
